import React from 'react';
import { IconWrapper } from '..';

export const IconNotificationsAlertTriangleOutline = IconWrapper(
    (
        upperProps: React.SVGProps<SVGSVGElement> & {
            secondaryColor?: string;
        },
    ) => {
        const { secondaryColor, ...props } = upperProps;
        return (
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.442 15.953L15.436 3.978a3.974 3.974 0 00-6.873 0l-7.008 11.98a4.007 4.007 0 003.419 6.04h14.038a4.005 4.005 0 003.43-6.045zm-19.164 1.02l7.013-11.988a1.976 1.976 0 013.416-.003l7.01 11.985a2.007 2.007 0 01-1.714 3.031H4.983a2.004 2.004 0 01-1.705-3.024zM12 17.999a1 1 0 100-2 1 1 0 000 2zm1.004-10h-2.001v7h2v-7z"
                    fill="currentColor"
                />
            </svg>
        );
    },
);
